import styled from '@emotion/styled';
import { Flex } from '../../atoms/Flex/Flex';

export const Container = styled(Flex)``;
